import dayjs from "dayjs";
import { API_DATE_FORMAT } from "api/constants";

export const today = dayjs().format(API_DATE_FORMAT);
